/**
 * Compatibilidade formato de resumo × canal de entrega (ops_intelligence).
 */

export const ALL_FORMATS = [
  "text",
  "audio",
  "image_chart",
  "infographic",
  "video_narrated",
  "video_animated",
];

export const CHANNEL_ALLOWED_FORMATS = {
  sms: ["text"],
  voice: ["text", "audio"],
  email: [...ALL_FORMATS],
  whatsapp: [...ALL_FORMATS],
};

export const CHANNEL_FORMAT_HINTS = {
  sms: "SMS só envia texto curto. Áudio, imagem e vídeo ficam indisponíveis neste canal.",
  voice:
    "Telefone toca o áudio (ou lê o texto). Imagem e vídeo não entram na ligação — use WhatsApp ou e-mail.",
  email:
    "E-mail leva o resumo em HTML. Mídias geradas também vão ao chat da equipe, com links no corpo do e-mail.",
  whatsapp:
    "WhatsApp oficial (Cloud/Gupshup) exige um template Utilidade por formato. WhatsApp QR envia mídia na sessão, sem template.",
};

export function normalizeDeliveryChannel(channel) {
  const c = String(channel || "")
    .trim()
    .toLowerCase();
  if (Object.prototype.hasOwnProperty.call(CHANNEL_ALLOWED_FORMATS, c)) return c;
  return "email";
}

export function allowedFormatsForChannel(deliveryChannel) {
  const channel = normalizeDeliveryChannel(deliveryChannel);
  return [...(CHANNEL_ALLOWED_FORMATS[channel] || CHANNEL_ALLOWED_FORMATS.email)];
}

export function isFormatAllowedForChannel(formatKey, deliveryChannel) {
  const key = String(formatKey || "").trim();
  return allowedFormatsForChannel(deliveryChannel).includes(key);
}

export function pruneFormatsForChannel(formats, deliveryChannel) {
  const allowed = new Set(allowedFormatsForChannel(deliveryChannel));
  const input = Array.isArray(formats) ? formats.map(String) : ["text"];
  const pruned = [];
  const kept = [];
  for (const f of input) {
    if (allowed.has(f)) kept.push(f);
    else pruned.push(f);
  }
  if (!kept.includes("text")) kept.unshift("text");
  const media = kept.filter((f) => f !== "text");
  const next = kept.includes("text") ? ["text"] : [];
  if (media[0]) next.push(media[0]);
  for (const extra of media.slice(1)) pruned.push(extra);
  return { formats: [...new Set(next)], pruned: [...new Set(pruned)] };
}

export function channelFormatHint(deliveryChannel) {
  const channel = normalizeDeliveryChannel(deliveryChannel);
  return CHANNEL_FORMAT_HINTS[channel] || CHANNEL_FORMAT_HINTS.email;
}
